import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|budgetId|allocationId|configuredByMemberId|ownerMemberId|creatorMemberId|memberId|createdByMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

    /** Private Journey budget — Planning finance only (no expense/split/payment modules). */
export const journeyBudgetApi = {
  get: (journeyId) => travelClient.get(
    travelEndpoints.journeyBudget(journeyId),
    snowflakeJson,
  ),
  getSummary: (journeyId) => travelClient.get(
    travelEndpoints.journeyBudgetSummary(journeyId),
    snowflakeJson,
  ),
  set: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyBudget(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, body) => travelClient.patch(
    travelEndpoints.journeyBudget(journeyId),
    body,
    snowflakeJson,
  ),
};
